export const makeId = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const recognizeDeviceState = (state) => {
    switch (state.toLowerCase()) {
        case '0':
            return 'آنلاین';
        case '1':
            return 'دریافت دستور';
        case '2':
            return 'اتصال به اینترنت';
        case '3':
            return 'ریست';
        case '4':
            return 'خاموش';
        case '5':
            return 'روشن';
        case '6':
            return 'بازنشانی EEPROM';
        case '7':
            return 'بروز رسانی فرمور';
        case '8':
            return 'خواندن ریموت';
        case '9':
            return 'خواندن مادون قرمز';
        case 'D':
            return 'ارسال ریموت';
        default:
            return 'ناشناخته';
    }
}